import React, { Suspense } from 'react';
import { Spinner } from "react-bootstrap";

import Belt from '../components/Belt';
import BeltLogged from '../components/BeltLogged';

import Footer from '../components/Footer';

import FechGetSparingpartnerUserAdverb from "../fechData/FechGetSparingpartnerUserAdverb";

import AuthService from "../services/auth.service";

//UTILS
import DateTimeNow from "../utils/DateTimeNow";

const AdverbUserSparingParnerShort = React.lazy(() => import('../components/AdverbUserSparingParnerShort'));

class ProfileSparingPage extends React.Component {

    state = {
        currentUser: AuthService.getCurrentUser(),
        title: "Profil Sparingparnerzy RezerwujKort.pl",
        restUserAdverbData: {
            successful: false,
            status: '',
            message: '',
            data: []
        },
    }

    async componentDidMount() {
        document.title = this.state.title

        try {
            this.setState({ loading: true });
            const response = await FechGetSparingpartnerUserAdverb();
            this.setState({
            restUserAdverbData: response,
            loading: false
            });
        } catch (error) {
            console.error("Błąd pobierania ogłoszeń:", error);
            this.setState({ loading: false });
        }
    }


    render() {

        var adverbs;
        if (this.state.restUserAdverbData.data.content != null && typeof this.state.restUserAdverbData.data.content.map === 'function') {
            adverbs = this.state.restUserAdverbData.data.content.map(adverbOne =>
                <div>
                    <Suspense fallback={<div>
                        <Spinner style={{ 'borderStyle': 'dotted', 'marginLeft': '50%' }} animation="border" />
                    </div>}>
                        <AdverbUserSparingParnerShort adverb={adverbOne} />
                    </Suspense>
                </div>);
        } else {
            adverbs = "";
        }

        return (

            <div>

                <Belt />

                <BeltLogged />

                <div id="content">
                    <div class="container">

                        <div class="main-subpage">
                            <div class="head">

                                <img src={`/images/login.png`} />
                                <p>Sparingpartnerzy</p>
                            </div>


                            <div style={{ clear: 'both' }}>
                                <div class="main-subpage-subtitle">Sparingpartnerzy</div>

                                {adverbs}

                            </div>


                        </div>


                    </div>
                </div>

                <Footer />

            </div>
        );
    }
}
export default ProfileSparingPage;
